var _ellipse, _path, _path2, _rect, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 47,
    viewBox: "0 0 35 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5,
    cy: 45.2198,
    rx: 17.5,
    ry: 1.7803,
    fill: "#C6B7E6",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3385 39.1587C14.3646 39.1588 14.3906 39.1588 14.4166 39.1588H14.2624C14.2877 39.1588 14.3131 39.1588 14.3385 39.1587ZM0 26.6308C0 36.378 8.32834 39.135 14.3385 39.1587C15.1562 39.1554 16.0256 39.0987 16.9162 38.9769C18.5661 40.0831 20.5321 40.7251 22.6426 40.7251C28.4784 40.7251 33.2092 35.8162 33.2092 29.7607C33.2092 25.1759 30.4973 21.2484 26.6473 19.611C23.8034 14.1142 18.9821 9.39812 18.9821 9.39812L22.2673 2.01511C22.721 1.09843 22.0906 0 21.1114 0H7.57068C6.58841 0 5.95952 1.09843 6.41172 2.01511L9.69993 9.39812C9.69993 9.39812 0 18.8849 0 26.6308Z",
    fill: "url(#paint0_linear_977_1517)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81177 29.6954C9.81177 22.6667 15.3029 16.9688 22.0765 16.9688C28.8501 16.9688 34.3412 22.6667 34.3412 29.6954C34.3412 36.7241 28.8501 42.422 22.0765 42.422C15.3029 42.422 9.81177 36.7241 9.81177 29.6954ZM32.1768 29.6954C32.1768 23.907 27.6548 19.2146 22.0765 19.2146C16.4982 19.2146 11.9761 23.907 11.9761 29.6954C11.9761 35.4837 16.4982 40.1761 22.0765 40.1761C27.6548 40.1761 32.1768 35.4837 32.1768 29.6954Z",
    fill: "#2C61C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.803734,
    x: 6.54126,
    y: 8.48438,
    width: 15.095,
    height: 2.34953,
    rx: 1.17477,
    fill: "#D4AA64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0462 33.9375C17.4291 33.9375 17.7394 33.6272 17.7394 33.2444V26.7119H21.5834C22.7178 26.7119 23.2061 27.4475 23.2061 28.6573V29.844C23.2061 30.2269 23.5165 30.5372 23.8993 30.5372C24.2822 30.5372 24.5925 30.2269 24.5925 29.844V28.6246C24.5925 27.7581 24.4507 27.186 24.1987 26.7282C23.7418 25.8945 22.9383 25.4531 21.8513 25.4531H16.353V33.2444C16.353 33.6272 16.6634 33.9375 17.0462 33.9375ZM22.3397 33.9375C26.1522 33.9375 28.1687 31.845 28.1687 28.2976V26.1069C28.1687 25.7458 27.876 25.4531 27.5149 25.4531C27.1538 25.4531 26.8611 25.7458 26.8611 26.1069V28.1995C26.8611 31.1258 25.396 32.7115 22.4184 32.7115H21.1266V29.0658C21.1266 28.7048 20.8339 28.412 20.4728 28.412C20.1117 28.412 19.819 28.7048 19.819 29.0658V33.9375H22.3397Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_1517",
    x1: 0.835808,
    y1: 9.85506,
    x2: 20.5933,
    y2: 46.2937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2799DF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.452196c9e5c0c9e64a8ae7aa444a182f.svg";
export { ForwardRef as ReactComponent };